import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import ContactInfoPage from './ContactInfoPage';

const ContactInfoRoute: FuseRouteItemType = {
  path: '',
  element: <ContactInfoPage />,
};

export default ContactInfoRoute;
